/**
 * The same per-day numbers as the bar strip, as rows: for reading exact values
 * and comparing days side by side. Newest first. The date cell is a button, so
 * selecting a day works from the keyboard without putting a click handler on
 * the row.
 */
import PropTypes from "prop-types";
import {
  dayTitle,
  formatCount,
  formatDistance,
  formatCharge,
  formatDuration,
  formatPct,
  formatRate,
} from "./robotTelemetry";

const COLUMNS = [
  { key: "runs", label: "Runs", render: (d) => formatCount(d.runs) },
  { key: "successRate", label: "Success", render: (d) => formatRate(d.successRate) },
  { key: "distanceM", label: "Distance", render: (d) => formatDistance(d.distanceM) },
  { key: "movingTimeSec", label: "Time moving", render: (d) => formatDuration(d.movingTimeSec) },
  { key: "batteryUsedPct", label: "Battery used", render: (d) => formatCharge(d.batteryUsedPct) },
  { key: "avgBatteryPerRunPct", label: "Per run", render: (d) => formatPct(d.avgBatteryPerRunPct) },
];

const NAV_COLUMNS = [
  { key: "recoveries", label: "Recoveries", render: (d) => formatCount(d.recoveries) },
  { key: "aborted", label: "Aborted", render: (d) => formatCount(d.aborted) },
];

const DayTable = ({ days, selected, today, onSelect, showNavigation }) => {
  const columns = showNavigation ? [...COLUMNS, ...NAV_COLUMNS] : COLUMNS;
  const rows = [...days].reverse();

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="rt-table">
        <caption className="rt-sr">Telemetry per day, newest first</caption>
        <thead>
          <tr>
            <th scope="col">Day</th>
            {columns.map((c) => (
              <th key={c.key} scope="col">
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((d) => {
            const isSelected = d.date === selected;
            return (
              <tr key={d.date} aria-selected={isSelected}>
                <th scope="row" style={{ fontWeight: isSelected ? 700 : 500 }}>
                  <button
                    type="button"
                    className="rt-rowbtn"
                    aria-pressed={isSelected}
                    onClick={() => onSelect(d.date)}
                  >
                    {dayTitle(d.date, today)}
                  </button>
                </th>
                {columns.map((c) => (
                  <td key={c.key} style={{ color: d.runs ? "var(--bq-text)" : "var(--bq-text3)" }}>
                    {c.render(d)}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

DayTable.propTypes = {
  days: PropTypes.array.isRequired,
  selected: PropTypes.string.isRequired,
  today: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  showNavigation: PropTypes.bool,
};

export default DayTable;
